// Components==============
import loginUser from 'actions/authentication/login';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useFormValues } from 'utilities/useFormValues';
import Button from '../Button';
import { TextInput } from '../Form/Input';
import Modal from '../Modal';
import './LoginModal.module.scss';
// =========================

export default function LoginModal({ setModalIsOpen }) {
    const dispatch = useDispatch();
    const [error, setError] = useState(false);

    const { formValues, handleChange } = useFormValues({
        email: '',
        password: '',
    });

    const { email, password } = formValues;

    useEffect(() => {
        // get cookie we need for loggin in
        axios.get('/sanctum/csrf-cookie').then(() => {});
    }, []);

    function handleSubmit(e) {
        e.preventDefault();

        dispatch(
            loginUser({
                email,
                password,
            })
        )
            .then((r) => {
                console.log(r);
                setModalIsOpen(false);
            })
            .catch(() => {
                setError(true);
            });
    }

    return (
        <Modal closeModal={() => setModalIsOpen(false)}>
            <form onSubmit={handleSubmit}>
                <div styleName="wrapper">
                    <TextInput
                        label="E-mailadres *"
                        name="email"
                        type="email"
                        value={email}
                        onChange={handleChange}
                    />
                    <TextInput
                        label="Wachtwoord *"
                        name="password"
                        type="password"
                        value={password}
                        onChange={handleChange}
                    />
                    {error && (
                        <p styleName="error">
                            Deze gegevens zijn helaas niet bekend
                        </p>
                    )}
                    <Button>log in</Button>
                </div>
            </form>
        </Modal>
    );
}
